import axios from 'axios';

const generateAIEmailDraft = async ({ token, data = {} } = {}) => {
  try {
    const response = await axios({
      method: 'post',
      url: `${process.env.REACT_APP_API_URL}/ai/email-draft`,
      data,
      headers: {
        Authorization: token,
      },
    });

    if (response instanceof Error) {
      return { error: response }
    }

    return response;
  } catch (error) {
    return { error };
  }
};

export default generateAIEmailDraft;
